import { render } from "./Artists.vue?vue&type=template&id=346a56ac&scoped=true"
import script from "./Artists.vue?vue&type=script&lang=js"
export * from "./Artists.vue?vue&type=script&lang=js"

import "./Artists.vue?vue&type=style&index=0&id=346a56ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346a56ac"]])

export default __exports__